{
    "Accessibility menu": "Tilgjengelighetsmeny",
    "Close": "Lukk",
    "Text and Reading": "Tekst og lesing",
    "Navigation and Interaction": "Navigasjon og interaksjon",
    "Text Align": "Tekstjustering",
    "Align Left": "Venstrejuster",
    "Align Center": "Midtstill",
    "Align Right": "Høyrejuster",
    "Adjust Font Size": "Juster tekststørrelse",
    "Highlight Title": "Fremhev tittel",
    "Highlight Links": "Fremhev lenker",
    "Readable Font": "Lesbar skrift",
    "Color and Contrast": "Farge og kontrast",
    "Dark Contrast": "Mørk kontrast",
    "Light Contrast": "Lys kontrast",
    "High Contrast": "Høy kontrast",
    "High Saturation": "Høy metning",
    "Low Saturation": "Lav metning",
    "Monochrome": "Monokrom",
    "Tools": "Verktøy",
    "Reading Guide": "Leseguide",
    "Big Cursor": "Stor markør",
    "Increase Font Size": "Øk tekststørrelse",
    "Decrease Font Size": "Reduser tekststørrelse",
    "Letter Spacing": "Bokstavavstand",
    "Line Height": "Linjehøyde",
    "Font Weight": "Skriftvekt",
    "Dyslexia Font": "Dysleksiskrift",
    "Language": "Språk",
    "Accessibility widget": "Åpne tilgjengelighetsmeny",
    "Accessibility Profiles": "Tilgjengelighetsprofiler",
    "Cognitive Disability": "Kognitiv funksjonshemming",
    "Seizure Safe": "Anfallssikker",
    "Accessibility statement": "Tilgjengelighetserklæring",
    "ADHD": "ADHD",
    "Low Vision": "Svaksynt",
    "Pause Animations": "Sett animasjoner på pause",
    "Animation paused": "Animasjon satt på pause",
    "Reset all settings": "Tilbakestill innstillinger",
    "Shortcut:": "Snarvei:",
    "Epilepsy Safe Mode": "Epilepsisikker modus",
    "Mute sounds": "Demp lyder",
    "Page read": "Les opp siden",
    "Page read controls": "Opplesingskontroller",
    "Pause": "Pause",
    "Resume": "Fortsett",
    "Stop": "Stopp",
    "Settings": "Innstillinger",
    "Speed": "Hastighet",
    "Voice": "Stemme",
    "Close accessibility menu": "Lukk tilgjengelighetsmeny",
    "Back to accessibility menu": "Tilbake til tilgjengelighetsmeny",
    "Search languages": "Søk etter språk",
    "Selected language": "Valgt språk",
    "View accessibility statement (opens in new window)": "Vis tilgjengelighetserklæring (åpnes i nytt vindu)",
    "Visit CookieYes website (opens in new window)": "Besøk CookieYes-nettstedet (åpnes i nytt vindu)",
    "Reset all accessibility settings to default": "Tilbakestill alle tilgjengelighetsinnstillinger"
}
